export default "/react/modal-trends-bg-398ec941.png";